import moment from "moment";
import dayjs from "dayjs";
import { BATCH_REPORT_TEST_STATUS } from "../../../utils/statusConfig";

const dateFormat = "MM/DD/YYYY";

export const COMPLETED_REPORT_STATUSES = ["Ready", "Ready-P", "Complete"];

export const defaultDateRange = (interval = "months") => {
  const startDate = moment().subtract(1, interval).format(dateFormat);
  const endDate = moment().format(dateFormat);
  return [dayjs(startDate, dateFormat), dayjs(endDate, dateFormat)];
};

export const resolveReportDelayStatus = (rawStatus) => {
  if (!rawStatus) return {};
  return BATCH_REPORT_TEST_STATUS[rawStatus] || {};
};
